/**
 * src/constants/roles.js
 *
 * L'ORDRE des fonctions, defini UNE fois.
 *
 * Il gouverne deux ecrans : le menu Fonction de la gestion des utilisateurs et
 * la liste des gabarits dans les parametres. Les deux doivent se lire pareil ;
 * une seconde copie finirait par diverger.
 *
 * Du plus large au plus etroit en acces, puis la comptabilite a part.
 */
export const ROLE_ORDER = [
  // `key` : la valeur en base (user_profiles.role, contrainte CHECK).
  // `templateName` : le nom EXACT du gabarit systeme sem  e par le trigger.
  //   Ce n'est pas un libelle d'interface — il ne se traduit pas, il sert a
  //   reconnaitre le gabarit quelle que soit la langue affichee.
  { key: 'admin',       templateName: 'Administrateur' },
  { key: 'pm',          templateName: 'Chargé de projet' },
  { key: 'assistant',   templateName: 'Assistant' },
  { key: 'coordinator', templateName: 'Coordonnateur' },
  { key: 'supervisor',  templateName: 'Surintendant' },
  { key: 'accountant',  templateName: 'Comptable' },
  // Aucune page web : son gabarit est vide. Il existe pour l'horaire des equipes
  // et pour OnSite+, pas pour l'application web.
  { key: 'worker',      templateName: 'Travailleur' },
];

/** Les sept cles de role, dans l'ordre. Pour les menus deroulants. */
export const ROLE_KEYS = ROLE_ORDER?.map((r) => r?.key);

const norm = (s) => (s || '')?.trim()?.toLowerCase();

/**
 * Rang d'un gabarit d'apres son nom. Un gabarit maison — ou un gabarit systeme
 * renomme — ne correspond a aucune fonction : il passe apres les six, ou il
 * sera trie par nom.
 */
export const templateRank = (name) => {
  const i = ROLE_ORDER?.findIndex((r) => norm(r?.templateName) === norm(name));
  return i === -1 ? ROLE_ORDER?.length : i;
};

/** Tri d'affichage : les sept fonctions dans l'ordre, puis le reste par nom. */
export const sortTemplatesByRole = (templates = []) =>
  [...(templates || [])]?.sort((a, b) => {
    const ra = templateRank(a?.name);
    const rb = templateRank(b?.name);
    if (ra !== rb) return ra - rb;
    return (a?.name || '')?.localeCompare(b?.name || '', 'fr');
  });

export default ROLE_ORDER;
